import { render, staticRenderFns } from "./ApplicantCard.vue?vue&type=template&id=7027684c&scoped=true&"
import script from "./ApplicantCard.vue?vue&type=script&lang=js&"
export * from "./ApplicantCard.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantCard.vue?vue&type=style&index=0&id=7027684c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7027684c",
  null
  
)

export default component.exports